var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classnames from 'classnames';
import * as React from 'react';
import { ConversationTimestamp } from 'components/conversation/components/conversationTimestamp/conversationTimestamp';
import sharedStyles from '../message/message.module.scss';
import styles from './messageStatus.module.scss';
export const MessageStatus = (_a) => {
    var { className, text, date, newest } = _a, otherProps = __rest(_a, ["className", "text", "date", "newest"]);
    const rootClass = classnames({
        [styles.messageStatus]: true,
    }, className);
    return (_jsxs("div", Object.assign({}, otherProps, { className: rootClass }, { children: [text, _jsx("div", Object.assign({ className: styles.date }, { children: !!date && (_jsx(ConversationTimestamp, { time: date, relative: newest, textProps: { className: sharedStyles.timestamp } })) }))] })));
};
